import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Page } from '@/model/document2/page/page';
import { Surface } from '@/model/document2/page/surface/surface';
import { Design } from '@/model/document2/page/surface/design/design';
import { DocumentHelper } from '@/helper/documentHelper';

// 複数デザインのコピーコマンド
export class CopyMultiDesignCommand implements ICommandBase
{
    private design! : Design;
    private surface! : Surface;
    private targetPositionArray! : Array<number>

    private startCallback : () => void;
    private finishCallback : () => void;

    private orgDesigns : { [ position : number ] : Design | null } = {};

    constructor(design : Design, surface : Surface, targetPositionArray : Array<number>, startCallback : () => void, finishCallback : () => void)
    {
        this.design = design;
        this.surface = surface;
        this.targetPositionArray = targetPositionArray;
        this.startCallback = startCallback;
        this.finishCallback = finishCallback;
        
        // コピー先の元のデザインを保持(存在しない場合はnull)
        for(var i = 0; i < targetPositionArray.length; ++i)
        {
            var pos = targetPositionArray[i];
            this.orgDesigns[pos] = surface.getDesign(pos);
        }
    }

    public do() : void
    {
        // 開始コールバック
        this.startCallback();
        // 以下の処理は非同期で実行する
        setTimeout(() => 
        {
            // 終了コールバックを非同期で実行する
            setTimeout(() =>
            {
                this.finishCallback();
            }, 100);

            for(var i = 0; i < this.targetPositionArray.length; ++i)
            {
                var pos = this.targetPositionArray[i];
                // コピー元の複製をとる。
                var clonedDesign = this.design.clone();
                // 連番のクローンを取り消す
                DocumentHelper.unityNumberLayersLink(clonedDesign, this.design);
                // リサイズ
                var designRect = this.surface.getDesignRect(pos);
                clonedDesign.width = clonedDesign.rotate == 90 || clonedDesign.rotate == 270 ? designRect.height : designRect.width;
                clonedDesign.height = clonedDesign.rotate == 90 || clonedDesign.rotate == 270 ? designRect.width : designRect.height;
                // 複製をコピー先にセット。
                this.surface.setDesign(pos, clonedDesign);
            }
        }, 100);
    }

    public undo() : void
    {
        for(var pos in this.orgDesigns)
        {
            var orgDesign = this.orgDesigns[pos];
            if(orgDesign != null)
            {
                // 元のデザインをコピー先にセット。
                this.surface.setDesign(pos, orgDesign);
            }
            else
            {
                // コピーしたデザインを削除。
                this.surface.removeDesign(pos);
            }
        }
    }

    public redo() : void
    {
        this.do();
    }
}